import { useContext } from "react";
import { useStore } from "zustand";
import Context from "./context";
import type { StoreActions, StoreState } from "./types";

export function useFundPageStore<T>(
	selector: (store: StoreState & StoreActions) => T,
): T {
	const store = useContext(Context);
	if (!store) throw new Error("Store not found");
	return useStore(store, selector);
}
